<template>
    <v-form :name="props.searchProps.formName"
            @keyup.enter="autoSearch = true">
        <Tabs value="0"
              scrollable>

            <TabList class="mb-4">
                <Tab value="0">{{ __('Basic data') }}</Tab>
            </TabList>

            <TabPanels>
                <TabPanel value="0">
                    <div class="grid">
                        <FormInputText fieldName="product_name"
                                       label="Product name"
                                       size="6"
                                       :isFocus="true"
                                       v-model:field="search.product_name" />

                        <FormMultiselect fieldName="assortment_id"
                                         label="Assortment"
                                         size="6"
                                         showClear
                                         :options="select?.assortments"
                                         v-model:field="search.assortment" />
                    </div>
                    <div class="grid">
                        <FormInputText fieldName="part_number"
                                       label="Part number"
                                       size="3"
                                       v-model:field="search.part_number" />

                        <FormInputText fieldName="features"
                                       label="Features"
                                       size="3"
                                       v-model:field="search.features" />

                        <FormInputText fieldName="unit"
                                       label="Unit"
                                       size="2"
                                       v-model:field="search.unit" />

                        <FormInputNumber fieldName="price_from"
                                         label="Price from"
                                         size="2"
                                         v-model:field="search.price_from" />

                        <FormInputNumber fieldName="price_to"
                                         label="Price to"
                                         size="2"
                                         v-model:field="search.price_to" />

                    </div>
                </TabPanel>
            </TabPanels>
        </Tabs>

        <div class="grid">
            <SearchButtons :searchProps="searchProps"
                           :search="search"
                           v-model:autoSearch="autoSearch" />
        </div>
    </v-form>
</template>

<script setup>
import { ref } from "vue";
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import FormInputText from '@crud/FormInputText.vue'
import FormMultiselect from '@crud/FormMultiselect.vue'
import FormInputNumber from '@crud/FormInputNumber.vue'
import SearchButtons from '@crud/SearchButtons.vue'
import { prepareSearch } from '@pages/Helper/crud_utils.js'
import { __ } from '@helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
    searchProps: Object,
})
const autoSearch = ref(false)

let search = ref({})

const options = ['assortments'];
const select = ref(null);

prepareSearch(search, props, options, select)

</script>

<style lang="scss" scoped></style>
